import { mediaCatalog } from './Reducers/MediaCatalog.reducer';

export const pnMediaCatalog = {
    mediaCatalog
};